import i18next from "i18next"

export const schema = {
   "$id": "http://obike.fr/schemas/auth_store_register_consumer_bike_input.json",
   "title": "Consumer Bike Register Query Schema",
   "type": "object",
   "additionalProperties": false,
   "properties": {
      "bike_id": {
         "type": "string",
         "pattern": "^[A-Z0-9]{7,}$",
         "errorMessage": {
            "pattern": i18next.t("error_bike_id_length", { ns: "bikeCollectionImport" })
         }
      },
      "bike_status": {
         "type": "integer",
         "enum": [
            1
         ]
      },
      "bike_description": {
         "type": "object",
         "additionalProperties": false,
         "properties": {
            "gear_type_id": {
               "type": "integer"
            },
            "gear_type": {
               "type": "string",
               "minLength": 1,
            },
            "brand_id": {
               "type": "integer"
            },
            "brand": {
               "type": "string",
               "minLength": 1,
            },
            "model": {
               "type": "string",
               "minLength": 1,
            },
            "color": {
               "type": "string",
               "minLength": 1,
            },
            "is_electric": {
               "type": "boolean",
               "errorMessage": {
                  "type": i18next.t("error_bike_description_empty_electric", { ns: "bikeCollectionImport" })
               }
            },
            "frame_serial_number": {
               "type": "string",
               "minLength": 1
            },
            "engine_serial_number": {
               "type": "string",
               "minLength": 1
            },
            "battery_serial_number": {
               "type": "string",
               "minLength": 1
            },
            "bike_ocode_id": {
               "type": "string",
               "pattern": "^[0-9]+$"
            }
         },
         "required": [
            "gear_type",
            "brand",
            "model",
            "color",
            "is_electric"
         ],
         "errorMessage": {
            "required": {
               "gear_type": i18next.t("error_bike_description_empty_type", { ns: "bikeCollectionImport" }),
               "brand": i18next.t("error_bike_description_empty_brand", { ns: "bikeCollectionImport" }),
               "model": i18next.t("error_bike_description_empty_model", { ns: "bikeCollectionImport" }),
               "color": i18next.t("error_bike_description_empty_color", { ns: "bikeCollectionImport" }),
               "is_electric": i18next.t("error_bike_description_empty_electric", { ns: "bikeCollectionImport" })
            },
         }
      },
      "bike_owner": {
         "type": "object",
         "oneOf": [
            {
               "type": "object",
               "additionalProperties": false,
               "properties": {
                  "consumer_id": {
                     "type": "string",
                     "pattern": "^[0-9]+$",
                  },
                  "entity_id": {
                     "type": "string",
                     "pattern": "^[0-9]+$",
                  }
               },
               "oneOf": [
                  {
                     "required": [
                        "consumer_id"
                     ]
                  },
                  {
                     "required": [
                        "entity_id"
                     ]
                  }
               ]
            },
            {
               "type": "object",
               "additionalProperties": false,
               "properties": {
                  "gender": {
                     "type": "integer",
                     "enum": [
                        1
                     ]
                  },
                  "first_name": {
                     "type": "string",
                     "minLength": 1
                  },
                  "last_name": {
                     "type": "string",
                     "minLength": 1,
                  },
                  "phone": {
                     "type": "string",
                     "pattern": "^\\+[1-9]\\d{1,14}$",
                  },
                  "mail": {
                     "type": "string",
                     "format": "email",
                  },
                  "address": {
                     "type": "object",
                     "additionalProperties": false,
                     "properties": {
                        "street_number": {
                           "type": "string",
                           "minLength": 1
                        },
                        "street_name": {
                           "type": "string",
                           "minLength": 1
                        },
                        "postal_code": {
                           "type": "string",
                           "minLength": 1
                        },
                        "insee_code": {
                           "type": "string",
                           "pattern": "^[0-9A-Z]{5}$"
                        },
                        "city": {
                           "type": "string",
                           "minLength": 1
                        },
                        "country": {
                           "type": "string",
                           "minLength": 1
                        }
                     },
                     "required": [
                        "street_name",
                        "city",
                        "country"
                     ],
                  },
                  "birth_date": {
                     "type": "string",
                     "pattern": "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
                  },
                  "birth_place": {
                     "type": "string",
                     "minLength": 1
                  },
                  "co_owner": {
                     "type": "object",
                     "additionalProperties": false,
                     "properties": {
                        "first_name": {
                           "type": "string",
                           "minLength": 1
                        },
                        "last_name": {
                           "type": "string",
                           "minLength": 1
                        },
                        "phone": {
                           "type": "string",
                           "pattern": "^\\+[1-9]\\d{1,14}$"
                        },
                        "mail": {
                           "type": "string",
                           "format": "email"
                        }
                     },
                     "required": [
                        "first_name",
                        "last_name"
                     ]
                  }
               },
               "required": [
                  "gender",
                  "first_name",
                  "last_name",
                  "phone",
                  "mail"
               ],
            },
            {
               "type": "object",
               "additionalProperties": false,
               "properties": {
                  "store_id": {
                     "type": "string",
                     "minLength": 1
                  },
                  "siret": {
                     "type": "string",
                     "minLength": 14
                  },
                  "gender": {
                     "type": "integer",
                     "enum": [
                        2
                     ]
                  },
                  "social_reason": {
                     "type": "string",
                     "minLength": 1
                  },
                  "phone": {
                     "type": "string",
                     "pattern": "^\\+[1-9]\\d{1,14}$"
                  },
                  "mail": {
                     "type": "string",
                     "format": "email"
                  },
                  "address": {
                     "type": "object",
                     "additionalProperties": false,
                     "properties": {
                        "street_number": {
                           "type": "string",
                           "minLength": 1
                        },
                        "street_name": {
                           "type": "string",
                           "minLength": 1
                        },
                        "postal_code": {
                           "type": "string",
                           "minLength": 1
                        },
                        "insee_code": {
                           "type": "string",
                           "pattern": "^[0-9A-Z]{5}$"
                        },
                        "city": {
                           "type": "string",
                           "minLength": 1
                        },
                        "country": {
                           "type": "string",
                           "minLength": 1
                        }
                     },
                     "required": [
                        "street_name",
                        "city",
                        "country"
                     ]
                  }
               },
               "required": [
                  "gender",
                  "social_reason",
                  "phone",
                  "mail"
               ],
            }
         ]
      },
      "send_notification_by_mail": {
         "type": "string",
         "enum": [
            "disable",
            "default",
            "SUNN",
            "INTER"
         ]
      },
      "send_receipt_by_mail": {
         "type": "string",
         "enum": [
            "disable",
            "default",
            "SUNN",
            "INTER"
         ]
      }
   },
   "required": [
      "bike_id",
      "bike_status",
      "bike_description",
      "bike_owner",
      "send_notification_by_mail",
      "send_receipt_by_mail"
   ],
   "errorMessage": {
      "required": {
         "bike_id": i18next.t("error_bike_id_empty", { ns: "bikeCollectionImport" }),
         "bike_description": i18next.t("error_bike_desc_empty", { ns: "bikeCollectionImport" }),
         "bike_owner": i18next.t("error_bike_owner_empty", { ns: "bikeCollectionImport" })
      }
   }
}